import React, { useState } from 'react';

function ContactUs() {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    message: ''
  });

  const handleChange = (e) => {
    const { id, value } = e.target;
    setFormData(prevData => ({
      ...prevData,
      [id]: value
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    // In a real application, you would send this data to a backend server
    // For now, we'll just log it to the console and show an alert
    console.log('Contact form submitted:', formData);

    // Create a contact message object similar to what the admin panel expects
    const contactMessage = {
      id: Date.now(), // Simple ID generation
      name: formData.name,
      email: formData.email,
      message: formData.message,
      date: new Date().toISOString().split('T')[0] // YYYY-MM-DD format
    };

    // In a real app, you would send this to your backend
    // For now, we'll just store it in localStorage so it can be accessed by the admin panel
    const existingMessages = JSON.parse(localStorage.getItem('contactMessages') || '[]');
    existingMessages.push(contactMessage);
    localStorage.setItem('contactMessages', JSON.stringify(existingMessages));

    // Reset form
    setFormData({
      name: '',
      email: '',
      message: ''
    });

    // Show success message
    alert('Thank you for your message! We will get back to you soon.');
  };

  return (
    <>
      {/* Main Content - "Contact Us" */}
      <main className="contact-main">
        <section className="contact-hero">
          <h1 className="contact-heading">CONTACT US</h1>

          <div className="contact-content">
            {/* Two-column layout */}
            <div className="contact-columns">
              {/* Left Column - Map Placeholder */}
              <div className="contact-map-column">
                <div className="map-placeholder">
                  <iframe
                    src="https://maps.google.com/maps?q=VShots+Pvt+Ltd+B+904+Venus+building+Veera+Desai+Road+Andheri+West+Mumbai+400053&t=&z=15&ie=UTF8&iwloc=&output=embed"
                    width="100%"
                    height="100%"
                    style={{ border: 0, borderRadius: '15px' }}
                    allowFullScreen=""
                    loading="lazy"
                    referrerPolicy="no-referrer-when-downgrade"
                    title="Our Location"
                  ></iframe>
                </div>
              </div>

              {/* Right Column - Contact Form */}
              <div className="contact-form-column">
                <form className="contact-form" onSubmit={handleSubmit}>
                  {/* Your Name Field */}
                  <div className="form-group">
                    <label htmlFor="name" className="animated-label">Full Name</label>
                    <input
                      type="text"
                      id="name"
                      value={formData.name}
                      onChange={handleChange}
                      placeholder="Enter Your Full Name"
                      className="form-input"
                      required
                    />
                  </div>

                  {/* Your E-mail Field */}
                  <div className="form-group">
                    <label htmlFor="email" className="animated-label">Work Email Address</label>
                    <input
                      type="email"
                      id="email"
                      value={formData.email}
                      onChange={handleChange}
                      placeholder="Enter Your Work Email Id"
                      className="form-input"
                      required
                    />
                  </div>

                  {/* Type your Message Field */}
                  <div className="form-group">
                    <label htmlFor="message" className="animated-label">Purpose </label>
                    <textarea
                      id="message"
                      value={formData.message}
                      onChange={handleChange}
                      placeholder="Enter Your Purpose Of Contacting Us…"
                      className="form-textarea"
                      required
                    ></textarea>
                  </div>

                  {/* Submit Button */}
                  <button type="submit" className="submit-btn">
                    Submit
                  </button>
                </form>
              </div>
            </div>
          </div>
        </section>
      </main>
    </>
  );
}

export default ContactUs;